import VideoJsAdapter from "@javascripts/adapters/videojs_adapter";
import Component from "../component";

export default class Index extends Component {

  constructor(player, options = {}){
    super(player, options);
  }

  createEl() {
    return super.createEl("div", { className: "vjs-control vjs-fill" });
  }
}

VideoJsAdapter.registerComponent('VpFiller', Index);
